import { render, staticRenderFns } from "./selfCount2.vue?vue&type=template&id=3577856b&scoped=true"
import script from "./selfCount2.vue?vue&type=script&lang=js"
export * from "./selfCount2.vue?vue&type=script&lang=js"
import style0 from "./selfCount2.vue?vue&type=style&index=0&id=3577856b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3577856b",
  null
  
)

export default component.exports